<template>
    <div>
        <h3 class="mb-3">{{ $t('update-password') }}</h3>

        <div v-if="success" class="alert alert-success">
            {{ $t('password-updated') }}
        </div>

        <PasswordInput
            v-model="new_password"
            :label="$t('new-password')"
            :error="validate && (!new_password || (!new_password !== !confirm_new_password))"
            :error-message="validate && new_password.length < 8 ? $t('password-too-short') : ''"
            autocomplete="new-password"
            show-strength
        />

        <PasswordInput
            v-model="confirm_new_password"
            :label="$t('confirm-new-password')"
            :error="validate && !confirm_new_password"
            :error-message="validate && new_password !== confirm_new_password ? $t('password-and-confirm-not-equal') : ''"
            autocomplete="new-password"
        />

        <button
            :disabled="!new_password || !confirm_new_password"
            type="button" class="btn btn-primary"
            @click="updatePassword"
        >
            {{ $t('update-password') }}
        </button>
    </div>
</template>

<script>

export default {
    props: {
        userId: Number,
    },
    data() {
        return {
            new_password: '',
            confirm_new_password: '',
            validate: false,
            success: false,
        }
    },
    methods: {
        async updatePassword() {
            this.success = false
            this.validate = true
            this.errors = false

            if (!this.requiresActivation) {
                if (!this.new_password) this.errors = true
                if (!this.confirm_new_password) this.errors = true
                if (this.new_password !== this.confirm_new_password ) this.errors = true
                if (this.new_password.length < 6) this.errors = true
            }

            if (this.errors) return

            try {
                this.$store.commit('showBlockingSpinner')

                const res = await this.$cfetch(`${this.$settings.APIBaseURL}/users/updatepassword`, {
                    method: 'POST',
                    data: {
                        id: this.userId,
                        new_password: this.new_password,
                        confirm_new_password: this.confirm_new_password,
                    }
                })

                this.$store.commit('hideBlockingSpinner')

                if (res.status === 'SUCCESS') {
                    this.validate = false
                    this.success = true
                    return
                } else {
                    this.$store.commit("openDialog", {
                        title: this.$t("something-went-wrong"),
                        content: this.$t('password-update-failed'),
                        confirmCallBack: function () {}
                    })
                }
            } catch (err) {
                this.$log.error.call(this, err)
            }
        },
    },
}
</script>
